module.exports = __webpack_public_path__ + "media/images/anders-87560074f264eea3b7975f134020981e.jpg";